import pick from 'lodash-es/pick'

import { FILTER_NAME_SUB_MENU } from '../../constants/filter'

import {
  POST_LIST_ALL_TAB,
  POST_LIST_TAB_NEWSBOARD,
  POST_LIST_TAB_REQUEST,
} from './Posts.constants'

export function getPermanentFilters({ filterValues }) {
  return pick(filterValues, [FILTER_NAME_SUB_MENU])
}

export function parsePermanentFilters(filters) {
  return [[FILTER_NAME_SUB_MENU, filters.sub_menu]]
}

export function getPostsTabs(t) {
  return [
    {
      id: POST_LIST_ALL_TAB,
      text: t('PostList.AllPostsTabKey'),
    },
    {
      id: POST_LIST_TAB_NEWSBOARD,
      text: t('PostList.NewsboardTabKey'),
    },
    {
      id: POST_LIST_TAB_REQUEST,
      text: t('PostList.RequestsTabKey'),
    },
  ]
}

export function filterItems({ post_type }, items) {
  return items?.filter(i => i.post_type.title !== post_type)
}
